import { selectNewbuildingBrokerConsultantBannerUrl } from './selectNewbuildingBrokerConsultantBannerUrl';
import { IAppState } from '../../common/state';

export function selectNewbuildingBrokerConsultantBannerAvailable(state: IAppState) {
  return Boolean(selectNewbuildingBrokerConsultantBannerUrl(state));
}
